export const productPackMicroData = (productUrl, staticProductData, page) => ({
  '@context': 'http://schema.org',
  '@type': 'Product',
  '@id': productUrl,
  name: staticProductData?.fields?.shopifyData?.title,
  url: productUrl,
  productID: staticProductData?.fields?.shopifyData?.variants[0]?.sku,
  sku: staticProductData?.fields?.shopifyData?.variants[0]?.sku,
  gtin13: staticProductData?.fields?.shopifyData?.variants[0]?.sku,
  brand: {
    '@type': 'Brand',
    name: 'https://www.nooz-optics.com/',
  },
  category: page?.seoMetadata?.title,
  material: page?.seoMetadata?.description?.description,
  color: staticProductData?.color?.shopifyKey,
  description: page?.seoMetadata?.description?.description,
  image: [
    staticProductData?.images[0]?.media?.gatsbyImageData?.images?.fallback?.src,
  ],
  model: staticProductData?.fields?.shopifyData?.title,
  offers: {
    '@type': 'Offer',
    priceCurrency:
      staticProductData?.fields?.shopifyData?.variants[0]?.priceV2
        ?.currencyCode,
    availability: 'http://schema.org/InStock',
    priceValidUntil: '2099-01-01T00:00:00',
    url: productUrl,
    priceSpecification: {
      '@type': 'CompoundPriceSpecification',
      name: 'Price',
      price:
        staticProductData?.fields?.shopifyData?.variants[0]?.priceV2?.amount,
      priceCurrency:
        staticProductData?.fields?.shopifyData?.variants[0]?.priceV2
          ?.currencyCode,

      priceComponent: [
        {
          name: 'VAT',
          price:
            staticProductData?.fields?.shopifyData?.variants[0]?.priceV2
              ?.amount,
          valueAddedTaxIncluded: true,
        },
      ],
    },
  },
});
